import ModalWrapper from "components/common/modals/modalWrapper/ModalWrapper";
import ReferringProviderForm from "../form/ReferringProviderForm";
import useReferringProviderModal from "../hooks/useReferringProviderModal";

const ReferringProviderModal = () => {
  const { showReferringProviderModal, isUpdateOperation, handleModalClose } =
    useReferringProviderModal();

  return (
    <ModalWrapper
      show={showReferringProviderModal}
      onClose={handleModalClose}
      fullWidth
      title={
        <span>{isUpdateOperation ? "Update" : "Add"} Referring Provider</span>
      }
    >
      <ReferringProviderForm />
    </ModalWrapper>
  );
};

export default ReferringProviderModal;
